@if(availableCurrencies.length){
<div class="form-item-card card border form-modal rounded-3">
  <div class="card-body pt-2 p-3">
    <div class="row g-3">
      <div class="col">
        <div class="form-label small fw-semibold text-muted text-uppercase uppercase d-block mb-2">Selecciona tu
          moneda</div>
        <div [formGroup]="form" class="d-flex gap-3">
          @for (code of availableCurrencies; track code; let i = $index) {
          <div class="form-check form-check-inline align-items-end d-flex gap-2 py-2">
            <input [id]="'insuranceCurrency' + i" [value]="code" class="form-check-input focus-ring focus-ring-success"
              formControlName="currency" sharedFormInput type="radio">
            <label [for]="'insuranceCurrency' + i" class="form-check-label fw-bold text-uppercase">{{
              currencyLabel(code)
              }}</label>
          </div>
          }
        </div>
        @if(currencyWarning) {
        <div class="alert alert-warning d-flex align-items-center gap-2 mt-2 py-2" role="alert">
          <app-icon [size]="20" name="triangle-alert"></app-icon>
          <div class="small fw-semibold">
            {{ currencyWarning }}
          </div>
        </div>
        }
        @if(currencyError) {
        <div class="alert alert-danger d-flex align-items-center gap-2 mt-2 py-2" role="alert">
          <app-icon [size]="20" name="circle-alert"></app-icon>
          <div class="small fw-semibold">
            {{ currencyError }}
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}